import React, { createContext, useContext, useState, useEffect } from 'react';
import { profileAPI } from '../services/api';

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    initProfile();
  }, []);

  const initProfile = async () => {
    try {
      setLoading(true);
      // Check if we have a saved profile ID
      const savedId = localStorage.getItem('kids_universe_profile_id');
      
      if (savedId) {
        try {
          const profileData = await profileAPI.getById(savedId);
          setProfile(profileData);
          return;
        } catch (e) {
          // Profile not found, create new
          localStorage.removeItem('kids_universe_profile_id');
        }
      }

      // Get or create by device ID
      const { profile: newProfile } = await profileAPI.getOrCreate('Explorer');
      setProfile(newProfile);
      localStorage.setItem('kids_universe_profile_id', newProfile.id);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async (updates) => {
    const updated = await profileAPI.update(profile.id, updates);
    setProfile(updated);
    return updated;
  };

  const refreshProfile = async () => {
    if (profile?.id) {
      const fresh = await profileAPI.getById(profile.id);
      setProfile(fresh);
    }
  };

  return (
    <ProfileContext.Provider value={{ profile, loading, error, updateProfile, refreshProfile }}>
      {children}
    </ProfileContext.Provider>
  );
}

export const useProfile = () => {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error('useProfile must be used inside ProfileProvider');
  return ctx;
};
